import { render, staticRenderFns } from "./PosStatisticsView.vue?vue&type=template&id=9762d3a6"
import script from "./PosStatisticsView.vue?vue&type=script&lang=js"
export * from "./PosStatisticsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports